// // import React, { useCallback, useEffect, useRef, useState } from "react";
// // import './Orders.scss'
// // import axios from "axios";
// // import _ from "lodash";
// // import returnIcon from "./Assets/returnIcon.svg";
// // import rupeesIcon from "./Assets/rupeesIcon.svg";
// // import deliveryIcon from './Assets/delivery.svg'
// // import { Products } from "../Products/Products";

// // export function Orders() {

// //     const [orderData, setOrderData] = useState([])
// //     const [searchVal, setSearchVal] = useState('')
// //     const [filterStatus, setFilterStatus] = useState({ OnTheWay: false, Delivered: false, Cancelled: false, Returned: false })
// //     const [filterTime, setFilterTime] = useState({ last_30_days: false, 2024: false })
// //     const [cartData, setCartData] = useState([]);

// //     const sizes = ["S", "M", "L", "XL"];
// //     const qty = [1, 2, 1, 1, 1];
// //     const order_size = "M"
// //     const order_qty = 1

// //     const [loading, setLoading] = useState(false);
// //     const [startRef, setStartRef] = useState(false);
// //     const [page, setPage] = useState(1);
// //     const [noMoreProducts, setNoMoreProducts] = useState(false);
// //     const observer = useRef();
// //     const footerObserver = useRef();
// //     const footerRef = useRef(null); // Ref for the footer element
// //     const [footerVisible, setFooterVisible] = useState(false);

// //     console.log('page - ', page);


// //     useEffect(() => {
// //         setCartData([{ sizes: [...sizes], qty: [...qty] }])
// //     }, [])

// //     const debouncedLoadMore = useCallback(
// //         _.debounce(() => {
// //             fetchOrders()
// //         }, 500),
// //         [page]
// //     );

// //     const searchProducts = () => {
// //         fetchOrders()
// //     }

// //     const lastProductRef = useCallback((node) => {
// //         console.log('in lastProductRef');

// //         console.log('loading - ', loading);
// //         console.log('noMoreProducts - ', noMoreProducts);
// //         console.log('footerVisible - ', footerVisible);
// //         console.log('startRef - ', startRef);


// //         if (loading || noMoreProducts || footerVisible || !startRef) return;

// //         if (observer.current) observer.current.disconnect();

// //         observer.current = new IntersectionObserver((entries) => {
// //             if (entries[0].isIntersecting) {
// //                 setPage((prevPage) => prevPage + 1);
// //             }
// //         });

// //         if (node) {
// //             observer.current.observe(node);

// //             const isElementVisible = node.getBoundingClientRect().top < window.innerHeight;
// //             if (isElementVisible) {
// //                 setPage((prevPage) => prevPage + 1);
// //             }
// //         }
// //     }, [loading, noMoreProducts, footerVisible, startRef]);

// //     // useEffect(() => {
// //     //     if (footerRef.current) {
// //     //         footerObserver.current = new IntersectionObserver((entries) => {
// //     //             setFooterVisible(entries[0].isIntersecting);
// //     //         });

// //     //         footerObserver.current.observe(footerRef.current);

// //     //         return () => {
// //     //             footerObserver.current.disconnect();
// //     //         };
// //     //     }
// //     // }, []);

// //     async function fetchOrders() {
// //         try {
// //             setLoading(true)
// //             const token = localStorage.getItem("token");
// //             const config = {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             };
// //             console.log('in fetchOrders');


// //             const filteredStatus = Object.keys(filterStatus).filter((key) => filterStatus[key]).map((key) => key)
// //             console.log('filteredStatus - ', filteredStatus);

// //             const filteredTime = Object.keys(filterTime).filter((key) => filterTime[key]).map((key) => key)
// //             console.log('filteredTime - ', filteredTime);

// //             // const response = await axios.get(
// //             //     `${API_BASE_URL}/orders/get-all`,
// //             //     config
// //             // );

// //             // let data = response.data;
// //             // console.log('fetchOrder response data - ', data);

// //             // setOrderData([...data])

// //             const response = await axios.post(
// //                 `${API_BASE_URL}/orders/get-all`,
// //                 {
// //                     filterStatus: filteredStatus,
// //                     filterTime: filteredTime,
// //                     searchVal,
// //                     page: 1,
// //                     size: 10
// //                 },
// //                 config
// //             );

// //             let data = response.data;
// //             console.log('fetchOrder response data - ', data);

// //             if (!data.length) {
// //                 setNoMoreProducts(true);
// //             }

// //             setOrderData([...orderData, ...data])
// //             // setOrderData([...data])
// //         }
// //         catch (error) {
// //             console.error("Failed to fetch products:", error);
// //         }
// //         finally {
// //             setLoading(false)
// //             setStartRef(true);
// //         }
// //     }

// //     useEffect(() => {
// //         // debouncedLoadMore()
// //         fetchOrders()
// //     }, [page])

// //     function handleStatusChange(key) {
// //         console.log('e target - ', key);
// //         console.log(!filterStatus[key]);


// //         setFilterStatus({ ...filterStatus, [key]: !filterStatus[key] })
// //     }

// //     function handleTimeChange(key) {
// //         console.log('e target - ', key);
// //         console.log(!filterTime[key]);

// //         if (key === "last_30_days") {
// //             setFilterTime({ '2024': false, [key]: !filterTime[key] })
// //         }
// //         else if (key === "2024") {
// //             setFilterTime({ 'last_30_days': false, [key]: !filterTime[key] })
// //         }
// //         // setFilterTime({ ...filterTime, [key]: !filterTime[key] })
// //     }

// //     function handleSearchChange(val) {
// //         if (val === "") {
// //             // Clear the state or perform any additional actions
// //             setSearchVal("")
// //         }
// //         setSearchVal(val)
// //     }

// //     console.log('Filters - ', filterStatus);
// //     console.log('searchVal - ', searchVal);
// //     console.log('orderData - ', orderData);


// //     return (
// //         <div className="oc-c">
// //             <div className="orders-container">
// //                 <div className="container">
// //                     {/* <div class="breadcrumbs-container">
// //                         <a href="/" class="breadcrumbs-link">
// //                             Home
// //                         </a>
// //                         <span class="breadcrumbs-separator">/</span>
// //                         <a href="/clothing" class="breadcrumbs-link">
// //                             Clothing
// //                         </a>
// //                         <span class="breadcrumbs-separator">/</span>
// //                         <a href="/men-clothing" class="breadcrumbs-link">
// //                             Men Clothing
// //                         </a>
// //                         <span class="breadcrumbs-separator">/</span>
// //                         <a href="/tshirts" class="breadcrumbs-link">
// //                             Tshirts
// //                         </a>
// //                         <span class="breadcrumbs-separator">/</span>
// //                         <a
// //                             href="/puma-tshirts"
// //                             class="breadcrumbs-bold-link breadcrumbs-link"
// //                         >
// //                             Puma Tshirts
// //                         </a>
// //                         <span class="breadcrumbs-bold-separator breadcrumbs-separator">
// //                             &gt;
// //                         </span>
// //                         <a href="/puma" class="breadcrumbs-bold-link breadcrumbs-link">
// //                             More by Puma
// //                         </a>
// //                     </div> */}

// //                     <div className="content-main">
// //                         {/* <div class="zInoZ3">
// //                             <div class="Pg+ADy JSTm7-">
// //                                 <div class="QGf71V">
// //                                     <div class="IhR2kR">
// //                                         <span>Filters</span>
// //                                     </div>
// //                                 </div>
// //                                 <div class="a+uPl0">
// //                                     <div class="_7ZFb8n">Order Status</div>
// //                                     <div class="PMPu+J" data-val="On_the_way">
// //                                         <label class="tJjCVx q97+Q6">
// //                                             <input type="checkbox" checked={filterStatus.OnTheWay} onChange={(e) => handleStatusChange('OnTheWay')} />
// //                                         </label>
// //                                         <div class="mRyhSz">On the way</div>
// //                                     </div>
// //                                     <div class="PMPu+J" data-val="Delivered">
// //                                         <label class="tJjCVx q97+Q6">
// //                                             <input type="checkbox" checked={filterStatus.Delivered} readonly="" onChange={(e) => handleStatusChange('Delivered')} />
// //                                         </label>
// //                                         <div class="mRyhSz">Delivered</div>
// //                                     </div>
// //                                     <div class="PMPu+J" data-val="Cancelled">
// //                                         <label class="tJjCVx q97+Q6">
// //                                             <input type="checkbox" checked={filterStatus.Cancelled} readonly="" onChange={(e) => handleStatusChange('Cancelled')} />
// //                                         </label>
// //                                         <div class="mRyhSz">Cancelled</div>
// //                                     </div>
// //                                     <div class="PMPu+J" data-val="Returned">
// //                                         <label class="tJjCVx q97+Q6">
// //                                             <input type="checkbox" checked={filterStatus.Returned} readonly="" onChange={(e) => handleStatusChange('Returned')} />
// //                                         </label>
// //                                         <div class="mRyhSz">Returned</div>
// //                                     </div>
// //                                 </div>
// //                                 <div class="a+uPl0">
// //                                     <div class="_7ZFb8n">Order Time</div>
// //                                     <div class="PMPu+J" data-val="Last_30_days">
// //                                         <label class="tJjCVx q97+Q6">
// //                                             <input type="checkbox" checked={filterTime.last_30_days} readonly="" onChange={(e) => handleTimeChange('last_30_days')} />
// //                                         </label>
// //                                         <div class="mRyhSz">Last 30 days</div>
// //                                     </div>
// //                                     <div class="PMPu+J" data-val="2024">
// //                                         <label class="tJjCVx q97+Q6">
// //                                             <input type="checkbox" checked={filterTime[2024]} readonly="" onChange={(e) => handleTimeChange('2024')} />
// //                                         </label>
// //                                         <div class="mRyhSz">2024</div>
// //                                     </div>
// //                                 </div>
// //                             </div>
// //                         </div> */}

// //                         {/* <div class="column sKUelf">
// //                             <div class="sgkCMD">
// //                                 <div class="_6NP6fD">
// //                                     <input
// //                                         type="text"
// //                                         class="CLxqQT"
// //                                         placeholder="Search your orders here"
// //                                         value={searchVal}
// //                                         fdprocessedid="ma9z58"
// //                                         onChange={(e) => handleSearchChange(e.target.value)}
// //                                     />
// //                                 </div>
// //                                 <button class="QqFHMw jSsVO- M5XAsp" fdprocessedid="ajv5wl">
// //                                     <div class="vdQTbU">
// //                                         <svg
// //                                             width="16"
// //                                             height="16"
// //                                             viewBox="0 0 17 18"
// //                                             class="NNw6HN"
// //                                             xmlns="http://www.w3.org/2000/svg"
// //                                         >
// //                                             <g fill="#fff" fill-rule="evenodd">
// //                                                 <path
// //                                                     class=""
// //                                                     d="m11.618 9.897l4.225 4.212c.092.092.101.232.02.313l-1.465 1.46c-.081.081-.221.072-.314-.02l-4.216-4.203"
// //                                                 ></path>
// //                                                 <path
// //                                                     class=""
// //                                                     d="m6.486 10.901c-2.42 0-4.381-1.956-4.381-4.368 0-2.413 1.961-4.369 4.381-4.369 2.42 0 4.381 1.956 4.381 4.369 0 2.413-1.961 4.368-4.381 4.368m0-10.835c-3.582 0-6.486 2.895-6.486 6.467 0 3.572 2.904 6.467 6.486 6.467 3.582 0 6.486-2.895 6.486-6.467 0-3.572-2.904-6.467-6.486-6.467"
// //                                                 ></path>
// //                                             </g>
// //                                         </svg>
// //                                         <span onClick={searchProducts}>Search Orders</span>
// //                                     </div>
// //                                 </button>
// //                             </div>
// //                             <div class="_36G8fB">1 results found</div>
// //                             <div>
// //                                 <div class="ejrH5a">
// //                                     <a
// //                                         class="_9rRUNC"
// //                                         href="/order_details?order_id=OD431140254828596100&amp;item_id=431140254828596100&amp;unit_id=431140254828596100000"
// //                                     >
// //                                         <div class="row">

// //                                             <div className="itemContainer-base-itemLeft">
// //                                                 <img src="https://rukminim2.flixcart.com/image/200/200/xif0q/t-shirt/f/u/v/l-psg-football-jersey-bodysports-co-original-imagpwaws73yh5ft.jpeg?q=90" />
// //                                             </div>

// //                                             <div className="itemContainer-base-itemRight">
// //                                                 <div className="brand-and-seller">
// //                                                     <div></div>
// //                                                     <a>Tribal Printed Oversized Cotton T-shirt</a>
// //                                                 </div>

// //                                                 <div className="itemComponents-base-sellerContainer">
// //                                                     <div className="itemComponents-base-sellerData">
// //                                                         Sold by: Puma Sports India Pvt. Ltd.(NSCM)
// //                                                     </div>
// //                                                 </div>


// //                                                 <div className="itemContainer-base-price">
// //                                                     <div>
// //                                                         <img src={rupeesIcon} />
// //                                                         300
// //                                                     </div>

// //                                                     <div>
// //                                                         <span>1500</span>

// //                                                         <span>60% OFF</span>
// //                                                     </div>
// //                                                 </div>

// //                                                 <div className="itemContainer-base-sizeAndQtyContainer">
// //                                                     <div className="itemContainer-base-sizeAndQty">

// //                                                         <div className="itemComponents-base-size">
// //                                                             <span>
// //                                                                 <div>Size:</div>
// //                                                                 <div
// //                                                                     className="cart-select"
// //                                                                 >
// //                                                                     m
// //                                                                 </div>
// //                                                             </span>
// //                                                         </div>


// //                                                         <div className="itemComponents-base-size">
// //                                                             <span>
// //                                                                 <div>Qty:</div>
// //                                                                 <div
// //                                                                     className="cart-select"
// //                                                                 >
// //                                                                     1
// //                                                                 </div>
// //                                                             </span>
// //                                                         </div>


// //                                                     </div>
// //                                                 </div>

// //                                                 <div className="rating-container">
// //                                                     <div className="overall-rating">
// //                                                         <div>{3.5}</div>
// //                                                         <span className="myntraweb-sprite"></span>
// //                                                         <span className="myntraweb-sprite"></span>
// //                                                         <span className="myntraweb-sprite"></span>
// //                                                         <div className="total_ratings">(360 Ratings)</div>
// //                                                     </div>
// //                                                 </div>


// //                                             </div>

// //                                             <div className="delivery-details">
// //                                                 <div className="container">
// //                                                     <div className="circle processed">
// //                                                         <div>Processed</div>
// //                                                     </div>
// //                                                     <div className="rectangle processed"></div>
// //                                                     <div className="circle processed">
// //                                                         <div>Shipped</div>
// //                                                     </div>
// //                                                     <div className="rectangle"></div>
// //                                                     <div className="circle">
// //                                                         <div>On Way</div>
// //                                                     </div>
// //                                                     <div className="rectangle"></div>
// //                                                     <div className="circle">
// //                                                         <div>Delivered</div>
// //                                                     </div>
// //                                                 </div>
// //                                             </div>

// //                                             <div className="options">
// //                                                 <div>Cancel</div>
// //                                                 <div>Delivery Status</div>
// //                                                 <div>Rate & Review</div>
// //                                             </div>
// //                                         </div>
// //                                         {
// //                                             orderData.map((order) => {
// //                                                 return (
// //                                                     <div class="row">
// //                                                         <div className="itemContainer-base-itemLeft">
// //                                                             <img src="https://rukminim2.flixcart.com/image/200/200/xif0q/t-shirt/f/u/v/l-psg-football-jersey-bodysports-co-original-imagpwaws73yh5ft.jpeg?q=90" />
// //                                                         </div>

// //                                                         <div className="itemContainer-base-itemRight">
// //                                                             <div className="brand-and-seller">
// //                                                                 <div></div>
// //                                                                 <a>{order?.title}</a>
// //                                                             </div>

// //                                                             <div className="itemComponents-base-sellerContainer">
// //                                                                 <div className="itemComponents-base-sellerData">
// //                                                                     Sold by: Puma Sports India Pvt. Ltd.(NSCM)
// //                                                                 </div>
// //                                                             </div>


// //                                                             <div className="itemContainer-base-price">
// //                                                                 <div>
// //                                                                     <img src={rupeesIcon} />
// //                                                                     {order?.price}
// //                                                                 </div>

// //                                                                 <div>
// //                                                                     <span>{order?.mrp}</span>

// //                                                                     <span>60% OFF</span>
// //                                                                 </div>
// //                                                             </div>

// //                                                             <div className="itemContainer-base-sizeAndQtyContainer">
// //                                                                 <div className="itemContainer-base-sizeAndQty">

// //                                                                     <div className="itemComponents-base-size">
// //                                                                         <span>
// //                                                                             <div>Size:</div>
// //                                                                             <div
// //                                                                                 className="cart-select"
// //                                                                             >
// //                                                                                 m
// //                                                                             </div>
// //                                                                         </span>
// //                                                                     </div>


// //                                                                     <div className="itemComponents-base-size">
// //                                                                         <span>
// //                                                                             <div>Qty:</div>
// //                                                                             <div
// //                                                                                 className="cart-select"
// //                                                                             >
// //                                                                                 1
// //                                                                             </div>
// //                                                                         </span>
// //                                                                     </div>


// //                                                                 </div>
// //                                                             </div>

// //                                                             <div className="rating-container">
// //                                                                 <div className="overall-rating">
// //                                                                     <div>{3.5}</div>
// //                                                                     <span className="myntraweb-sprite"></span>
// //                                                                     <span className="myntraweb-sprite"></span>
// //                                                                     <span className="myntraweb-sprite"></span>
// //                                                                     <div className="total_ratings">(360 Ratings)</div>
// //                                                                 </div>
// //                                                             </div>


// //                                                         </div>

// //                                                         <div className="delivery-details">
// //                                                             <div className="container">
// //                                                                 <div className="circle processed">
// //                                                                     <div>Processed</div>
// //                                                                 </div>
// //                                                                 <div className="rectangle processed"></div>
// //                                                                 <div className="circle processed">
// //                                                                     <div>Shipped</div>
// //                                                                 </div>
// //                                                                 <div className="rectangle"></div>
// //                                                                 <div className="circle">
// //                                                                     <div>On Way</div>
// //                                                                 </div>
// //                                                                 <div className="rectangle"></div>
// //                                                                 <div className="circle">
// //                                                                     <div>Delivered</div>
// //                                                                 </div>
// //                                                             </div>
// //                                                         </div>

// //                                                         <div className="options">
// //                                                             <div>Cancel</div>
// //                                                             <div>Delivery Status</div>
// //                                                             <div>Rate & Review</div>
// //                                                         </div>
// //                                                     </div>
// //                                                 )
// //                                             })
// //                                         }
// //                                     </a>
// //                                 </div>
// //                             </div>
// //                             <div class="Lua5dN">
// //                                 <div class="v0q-qo">
// //                                     <span>No more results to display</span>
// //                                 </div>
// //                             </div>
// //                         </div> */}
// //                         <div className="new-check-1">
// //                             {
// //                                 orderData.map((order) => {
// //                                     return (
// //                                         <div>{order.title}</div>
// //                                     )
// //                                 })
// //                             }
// //                         </div>
// //                     </div>

// //                     {/* <div ref={lastProductRef}></div>
// //                     <div ref={footerRef} className="fetch-stopper"></div> */}

// //                     {/* <div className="showstopper">stoper 1</div> */}

// //                 </div>
// //                 {/* <div className="showstopper">stoper 2</div> */}


// //             </div>
// //             {/* <div className="showstopper">stoper 3</div> */}

// //             {/* <Products /> */}

// //         </div>
// //     );
// // }





// import React, { useCallback, useEffect, useRef, useState } from "react";
// import './Orders.scss'
// import axios from "axios";
// import _ from "lodash";
// import returnIcon from "./Assets/returnIcon.svg";
// import rupeesIcon from "./Assets/rupeesIcon.svg";
// import deliveryIcon from './Assets/delivery.svg'
// import { Products } from "../Products/Products";
// // import './ProductSliderMulti.scss';
// import "../Components/images/ProductSliderMulti.scss"

// export function Orders({ slides }) {

//     // console.log('order slides - ', slides);


//     // const [orderData, setOrderData] = useState([])
//     // const [searchVal, setSearchVal] = useState('')
//     // const [filterStatus, setFilterStatus] = useState({ OnTheWay: false, Delivered: false, Cancelled: false, Returned: false })
//     // const [filterTime, setFilterTime] = useState({ last_30_days: false, 2024: false })
//     // const [cartData, setCartData] = useState([]);

//     // const sizes = ["S", "M", "L", "XL"];
//     // const qty = [1, 2, 1, 1, 1];
//     // const order_size = "M"
//     // const order_qty = 1

//     // const [loading, setLoading] = useState(false);
//     // const [startRef, setStartRef] = useState(false);
//     // const [page, setPage] = useState(1);
//     // const [noMoreProducts, setNoMoreProducts] = useState(false);
//     // const observer = useRef();
//     // const footerObserver = useRef();
//     // const footerRef = useRef(null); // Ref for the footer element
//     // const [footerVisible, setFooterVisible] = useState(false);

//     // console.log('page - ', page);


//     // useEffect(() => {
//     //     setCartData([{ sizes: [...sizes], qty: [...qty] }])
//     // }, [])

//     // const debouncedLoadMore = useCallback(
//     //     _.debounce(() => {
//     //         fetchOrders()
//     //     }, 500),
//     //     [page]
//     // );

//     // const searchProducts = () => {
//     //     fetchOrders()
//     // }

//     // const lastProductRef = useCallback((node) => {
//     //     console.log('in lastProductRef');

//     //     console.log('loading - ', loading);
//     //     console.log('noMoreProducts - ', noMoreProducts);
//     //     console.log('footerVisible - ', footerVisible);
//     //     console.log('startRef - ', startRef);


//     //     if (loading || noMoreProducts || footerVisible || !startRef) return;

//     //     if (observer.current) observer.current.disconnect();

//     //     observer.current = new IntersectionObserver((entries) => {
//     //         if (entries[0].isIntersecting) {
//     //             setPage((prevPage) => prevPage + 1);
//     //         }
//     //     });

//     //     if (node) {
//     //         observer.current.observe(node);

//     //         const isElementVisible = node.getBoundingClientRect().top < window.innerHeight;
//     //         if (isElementVisible) {
//     //             setPage((prevPage) => prevPage + 1);
//     //         }
//     //     }
//     // }, [loading, noMoreProducts, footerVisible, startRef]);

//     // // useEffect(() => {
//     // //     if (footerRef.current) {
//     // //         footerObserver.current = new IntersectionObserver((entries) => {
//     // //             setFooterVisible(entries[0].isIntersecting);
//     // //         });

//     // //         footerObserver.current.observe(footerRef.current);

//     // //         return () => {
//     // //             footerObserver.current.disconnect();
//     // //         };
//     // //     }
//     // // }, []);

//     // async function fetchOrders() {
//     //     try {
//     //         setLoading(true)
//     //         const token = localStorage.getItem("token");
//     //         const config = {
//     //             headers: { Authorization: `Bearer ${token}` }
//     //         };
//     //         console.log('in fetchOrders');


//     //         const filteredStatus = Object.keys(filterStatus).filter((key) => filterStatus[key]).map((key) => key)
//     //         console.log('filteredStatus - ', filteredStatus);

//     //         const filteredTime = Object.keys(filterTime).filter((key) => filterTime[key]).map((key) => key)
//     //         console.log('filteredTime - ', filteredTime);

//     //         // const response = await axios.get(
//     //         //     `${API_BASE_URL}/orders/get-all`,
//     //         //     config
//     //         // );

//     //         // let data = response.data;
//     //         // console.log('fetchOrder response data - ', data);

//     //         // setOrderData([...data])

//     //         const response = await axios.post(
//     //             `${API_BASE_URL}/orders/get-all`,
//     //             {
//     //                 filterStatus: filteredStatus,
//     //                 filterTime: filteredTime,
//     //                 searchVal,
//     //                 page: 1,
//     //                 size: 10
//     //             },
//     //             config
//     //         );

//     //         let data = response.data;
//     //         console.log('fetchOrder response data - ', data);

//     //         if (!data.length) {
//     //             setNoMoreProducts(true);
//     //         }

//     //         setOrderData([...orderData, ...data])
//     //         // setOrderData([...data])
//     //     }
//     //     catch (error) {
//     //         console.error("Failed to fetch products:", error);
//     //     }
//     //     finally {
//     //         setLoading(false)
//     //         setStartRef(true);
//     //     }
//     // }

//     // useEffect(() => {
//     //     // debouncedLoadMore()
//     //     fetchOrders()
//     // }, [page])

//     // function handleStatusChange(key) {
//     //     console.log('e target - ', key);
//     //     console.log(!filterStatus[key]);


//     //     setFilterStatus({ ...filterStatus, [key]: !filterStatus[key] })
//     // }

//     // function handleTimeChange(key) {
//     //     console.log('e target - ', key);
//     //     console.log(!filterTime[key]);

//     //     if (key === "last_30_days") {
//     //         setFilterTime({ '2024': false, [key]: !filterTime[key] })
//     //     }
//     //     else if (key === "2024") {
//     //         setFilterTime({ 'last_30_days': false, [key]: !filterTime[key] })
//     //     }
//     //     // setFilterTime({ ...filterTime, [key]: !filterTime[key] })
//     // }

//     // function handleSearchChange(val) {
//     //     if (val === "") {
//     //         // Clear the state or perform any additional actions
//     //         setSearchVal("")
//     //     }
//     //     setSearchVal(val)
//     // }

//     // console.log('Filters - ', filterStatus);
//     // console.log('searchVal - ', searchVal);
//     // console.log('orderData - ', orderData);


//     return (
//         <div className="product-slider-multi-web">
//             <div className="slide-main">
//                 {
//                     slides.map((order) => {
//                         return (
//                             <div>{order.title}</div>
//                         )
//                     })
//                 }
//             </div>
//         </div>
//     );
// }



import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import './Orders.scss'
import axios from "axios";
import _ from "lodash";
import { API_BASE_URL } from "../config";
import { PageLoadLoader } from "../Components/Loader";
import returnIcon from "./Assets/returnIcon.svg";
import rupeesIcon from "./Assets/rupeesIcon.svg";
import deliveryIcon from './Assets/delivery.svg'
import { getOrderItemVisibleOptions } from './getOrderItemVisibleOptions';
import { ORDERS_SEARCH_DEBOUNCE_MS } from './ordersConstants';
import { useToast } from '../Contexts/ToastContext';
import { mapOrderItemFromApi } from '../utils/orderPayload';
import { getOrderTracking } from '../api/delivery';

export function Orders() {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [orderData, setOrderData] = useState([])
    const [totalOrderItemsCount, setTotalOrderItemsCount] = useState(0)
    const [searchVal, setSearchVal] = useState('')
    const [debouncedSearchVal, setDebouncedSearchVal] = useState('')
    const searchDebounceTimerRef = useRef(null)
    const [filterStatus, setFilterStatus] = useState({ OnTheWay: false, Delivered: false, Cancelled: false, Returned: false })
    const [filterTime, setFilterTime] = useState({ last_30_days: false, 2024: false })
    const [cartData, setCartData] = useState([]);

    const sizes = ["S", "M", "L", "XL"];
    const qty = [1, 2, 1, 1, 1];
    const order_size = "M"
    const order_qty = 1

    const [loading, setLoading] = useState(true);
    const [startRef, setStartRef] = useState(false);
    const [page, setPage] = useState(1);
    const [noMoreProducts, setNoMoreProducts] = useState(false);
    const observer = useRef();
    const footerObserver = useRef();
    const footerRef = useRef(null); // Ref for the footer element
    const [footerVisible, setFooterVisible] = useState(false);
    const [cancellingOrder, setCancellingOrder] = useState(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showTrackModal, setShowTrackModal] = useState(false);
    const [trackLoading, setTrackLoading] = useState(false);
    const [trackInfo, setTrackInfo] = useState(null);
    const [showViewReviewModal, setShowViewReviewModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [cancelledItemIds, setCancelledItemIds] = useState([]);

    const breadcrumbs = [
        { label: 'Home', href: '/' },
        { label: 'My Account', href: '/account' },
        { label: 'My Orders', href: '/orders', isActive: true }
    ];

    console.log('page - ', page);


    useEffect(() => {
        setCartData([{ sizes: [...sizes], qty: [...qty] }])
    }, [])

    const debouncedLoadMore = useCallback(
        _.debounce(() => {
            fetchOrders()
        }, 500),
        [page]
    );

    const searchProducts = () => {
        if (searchDebounceTimerRef.current) {
            clearTimeout(searchDebounceTimerRef.current);
            searchDebounceTimerRef.current = null;
        }
        setOrderData([]);
        setPage(1);
        setNoMoreProducts(false);
        if (searchVal === debouncedSearchVal) {
            fetchOrders();
        } else {
            setDebouncedSearchVal(searchVal);
        }
    }

    // const lastProductRef = useCallback((node) => {
    //     console.log('in lastProductRef');

    //     console.log('loading - ', loading);
    //     console.log('noMoreProducts - ', noMoreProducts);
    //     console.log('footerVisible - ', footerVisible);
    //     console.log('startRef - ', startRef);


    //     if (loading || noMoreProducts || footerVisible || !startRef) return;

    //     if (observer.current) observer.current.disconnect();

    //     observer.current = new IntersectionObserver((entries) => {
    //         if (entries[0].isIntersecting) {
    //             setPage((prevPage) => prevPage + 1);
    //         }
    //     });

    //     if (node) {
    //         observer.current.observe(node);

    //         const isElementVisible = node.getBoundingClientRect().top < window.innerHeight;
    //         if (isElementVisible) {
    //             setPage((prevPage) => prevPage + 1);
    //         }
    //     }
    // }, [loading, noMoreProducts, footerVisible, startRef]);


    const lastProductRef = useCallback((node) => {
        if (loading || noMoreProducts || footerVisible || !startRef) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setPage((prevPage) => prevPage + 1);
            }
        });

        // if (node) {
        //   observer.current.observe(node);

        //   const isElementVisible = node.getBoundingClientRect().top < window.innerHeight;
        //   if (isElementVisible) {
        //     setPage((prevPage) => prevPage + 1);
        //   }
        // }

        if (node) {
            observer.current.observe(node);
            console.log('imtersection - ', node.getBoundingClientRect().top, " - ", window.innerHeight);
            if (node.getBoundingClientRect().top < 0) return
            const isElementVisible = node.getBoundingClientRect().top < window.innerHeight;
            if (isElementVisible) {
                setPage((prevPage) => prevPage + 1);
            }
        }
    }, [loading, noMoreProducts, footerVisible, startRef]);

    useEffect(() => {
        if (footerRef.current && !noMoreProducts) {
            footerObserver.current = new IntersectionObserver((entries) => {
                setFooterVisible(entries[0].isIntersecting);
            });

            footerObserver.current.observe(footerRef.current);

            return () => {
                if (footerObserver.current) {
                    footerObserver.current.disconnect();
                }
            };
        } else if (noMoreProducts && footerObserver.current) {
            // Clean up observer when no more products
            footerObserver.current.disconnect();
        }
    }, [noMoreProducts]);

    // Debounce search input → API query (avoids a request on every keystroke)
    useEffect(() => {
        if (searchDebounceTimerRef.current) {
            clearTimeout(searchDebounceTimerRef.current);
        }
        searchDebounceTimerRef.current = setTimeout(() => {
            searchDebounceTimerRef.current = null;
            setDebouncedSearchVal(searchVal);
        }, ORDERS_SEARCH_DEBOUNCE_MS);
        return () => {
            if (searchDebounceTimerRef.current) {
                clearTimeout(searchDebounceTimerRef.current);
                searchDebounceTimerRef.current = null;
            }
        };
    }, [searchVal]);

    async function fetchOrders() {
        try {
            setLoading(true)
            const token = localStorage.getItem("token");
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            console.log('in fetchOrders');

            const filteredStatus = Object.keys(filterStatus).filter((key) => filterStatus[key]).map((key) => key)
            console.log('filteredStatus - ', filteredStatus);

            const filteredTime = Object.keys(filterTime).filter((key) => filterTime[key]).map((key) => key)
            console.log('filteredTime - ', filteredTime);

            const response = await axios.post(
                '/orders/get-all',
                {
                    filterStatus: filteredStatus,
                    filterTime: filteredTime,
                    searchVal: debouncedSearchVal,
                    page: page,
                    size: 10
                },
                config
            );

            const { orders = [], totalOrderItemsCount: totalCount = 0 } = response.data || {};
            console.log('Orders response data - ', response.data);

            setTotalOrderItemsCount(totalCount);

            // Check if we got fewer orders than requested (indicating no more data)
            const requestedSize = 10;
            if (orders.length < requestedSize) {
                setNoMoreProducts(true);
            }

            const processedOrders = orders.map((item) => mapOrderItemFromApi(item, API_BASE_URL));

            console.log('Processed orders - ', processedOrders);

            if (page === 1) {
                setOrderData(processedOrders);
                if (orders.length >= requestedSize) {
                    setNoMoreProducts(false);
                }
            } else {
                // Append data for pagination
                setOrderData((prevOrderData) => [...prevOrderData, ...processedOrders]);
            }
        }
        catch (error) {
            console.error("Failed to fetch orders:", error);
        }
        finally {
            setLoading(false)
            setStartRef(true);
        }
    }

    // Initial fetch on mount
    useEffect(() => {
        setOrderData([]);
        setTotalOrderItemsCount(0);
        setPage(1);
        setNoMoreProducts(false);
        setStartRef(false);
        fetchOrders();
    }, []); // Only on mount

    // Fetch more when page changes (for pagination)
    useEffect(() => {
        if (page > 1 && startRef) {
            fetchOrders();
        }
    }, [page, footerVisible])

    // Refetch orders when filters or search change
    useEffect(() => {
        if (startRef) { // Only refetch if initial load is done
            setOrderData([]);
            setTotalOrderItemsCount(0);
            setPage(1);
            setNoMoreProducts(false);
            fetchOrders();
        }
    }, [filterStatus, filterTime, debouncedSearchVal])

    function handleStatusChange(key) {
        console.log('e target - ', key);
        console.log(!filterStatus[key]);


        setFilterStatus({ ...filterStatus, [key]: !filterStatus[key] })
    }

    console.log('test orderData - ', orderData);

    function handleTimeChange(key) {
        console.log('e target - ', key);
        console.log(!filterTime[key]);

        if (key === "last_30_days") {
            setFilterTime({ '2024': false, [key]: !filterTime[key] })
        }
        else if (key === "2024") {
            setFilterTime({ 'last_30_days': false, [key]: !filterTime[key] })
        }
        // setFilterTime({ ...filterTime, [key]: !filterTime[key] })
    }

    function handleSearchChange(val) {
        setSearchVal(val);
    }

    // Cancel single item (item-level cancel only)
    const handleCancelItemConfirm = async () => {
        if (!selectedOrder?.orderId || !selectedOrder?.orderItemId) return;
        try {
            setCancellingOrder(selectedOrder.orderId);
            const token = localStorage.getItem("token");
            const { data } = await axios.post(
                '/orders/cancel-item',
                {
                    orderId: selectedOrder.orderId,
                    product_id: selectedOrder.orderItemId,
                    selectedSize: selectedOrder.size || selectedOrder.selectedSize
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (data?.success) {
                setCancelledItemIds((prev) => (prev.includes(selectedOrder.id) ? prev : [...prev, selectedOrder.id]));
                setShowCancelModal(false);
                setSelectedOrder(null);
            } else {
                showToast({ message: data?.message || 'Failed to cancel item.' });
            }
        } catch (error) {
            console.error("Failed to cancel item:", error);
            showToast({ message: error.response?.data?.message || 'Failed to cancel item.' });
        } finally {
            setCancellingOrder(null);
        }
    };

    // Handle cancel button click - pass full order object
    const handleCancelClick = (order, e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedOrder(order);
        setShowCancelModal(true);
    };

    const openFeedback = (order, e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        navigate('/orders/feedback', { state: { orderItem: order } });
    };

    // Close modal
    const closeCancelModal = () => {
        setShowCancelModal(false);
        setSelectedOrder(null);
    };

    const openTrackModal = async (order) => {
        setSelectedOrder(order);
        setShowTrackModal(true);
        setTrackInfo(null);
        setTrackLoading(true);
        try {
            const data = await getOrderTracking(order.orderId);
            setTrackInfo(data);
        } finally {
            setTrackLoading(false);
        }
    };

    const closeTrackModal = () => {
        setShowTrackModal(false);
        setSelectedOrder(null);
        setTrackInfo(null);
        setTrackLoading(false);
    };

    const openViewReviewModal = (order) => {
        setSelectedOrder(order);
        setShowViewReviewModal(true);
    };

    const closeViewReviewModal = () => {
        setShowViewReviewModal(false);
        setSelectedOrder(null);
    };

    // Timeline status for progress bar (processed → shipped → on the way → delivered)
    const getTimelineStatus = (orderStatus, deliveryStatus) => {
        const status = (orderStatus || '').toString().trim().toLowerCase();
        const delivery = (deliveryStatus || '').toString().trim().toLowerCase();
        const isDelivered = status === 'delivered' || delivery === 'delivered' || delivery === 'completed';
        const isOnTheWay = delivery === 'ontheway' || delivery === 'on the way' || delivery === 'out for delivery';
        const isShipped = status === 'shipped' || delivery === 'shipped' || isOnTheWay || isDelivered;
        return {
            processed: 'completed',
            shipped: isShipped ? 'completed' : 'pending',
            onTheWay: isDelivered ? 'completed' : (isOnTheWay ? 'active' : 'pending'),
            delivered: isDelivered ? 'completed' : 'pending'
        };
    };

    const getProgressPercent = (orderItem) => {
        const s = (orderItem.itemStatus || '').toString().trim().toLowerCase();
        if (s === 'delivered') return 100;
        if (s === 'ontheway') return 75;
        if (s === 'shipped') return 50;
        return 25;
    };

    console.log('Filters - ', filterStatus);
    console.log('searchVal - ', searchVal);
    console.log('orderData - ', orderData);

    // Initial load: show full-page loader until first fetch completes
    if (loading && orderData.length === 0) {
        return <PageLoadLoader />;
    }

    return (
        <div className="orders-page-container">
            <div className="orders-main-wrapper">
                <div>
                    <div className="breadcrumbs-wrapper">
                        <div className="breadcrumbs-container breadcrumbs-design-6">
                            {breadcrumbs.map((crumb, index) => (
                                <React.Fragment key={index}>
                                    {index > 0 && (
                                        <span className="breadcrumbs-separator">/</span>
                                    )}
                                    {crumb.isActive ? (
                                        <span className="breadcrumbs-current">{crumb.label}</span>
                                    ) : (
                                        <a href={crumb.href} className="breadcrumbs-link">{crumb.label}</a>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    <div className="content-main">
                        <div class="filters-container">
                            <div class="filters-header-wrapper">
                                <div class="filters-header">
                                    <div class="filters-title">
                                        <span class="filter-icon">🔍</span>
                                        <span>Filters</span>
                                    </div>
                                </div>
                                <div class="filters-options">
                                    <div class="filter-section-title">Order Status</div>
                                    <label className="filter-option" data-val="On_the_way">
                                        <span className="filter-checkbox-label">
                                            <input type="checkbox" checked={filterStatus.OnTheWay} onChange={() => handleStatusChange('OnTheWay')} />
                                        </span>
                                        <span className="filter-option-text">On the way</span>
                                    </label>
                                    <label className="filter-option" data-val="Delivered">
                                        <span className="filter-checkbox-label">
                                            <input type="checkbox" checked={filterStatus.Delivered} onChange={() => handleStatusChange('Delivered')} />
                                        </span>
                                        <span className="filter-option-text">Delivered</span>
                                    </label>
                                    <label className="filter-option" data-val="Cancelled">
                                        <span className="filter-checkbox-label">
                                            <input type="checkbox" checked={filterStatus.Cancelled} onChange={() => handleStatusChange('Cancelled')} />
                                        </span>
                                        <span className="filter-option-text">Cancelled</span>
                                    </label>
                                    <label className="filter-option" data-val="Returned">
                                        <span className="filter-checkbox-label">
                                            <input type="checkbox" checked={filterStatus.Returned} onChange={() => handleStatusChange('Returned')} />
                                        </span>
                                        <span className="filter-option-text">Returned</span>
                                    </label>
                                </div>
                                <div class="filters-options">
                                    <div class="filter-section-title">Order Time</div>
                                    <label className="filter-option" data-val="Last_30_days">
                                        <span className="filter-checkbox-label">
                                            <input type="checkbox" checked={filterTime.last_30_days} onChange={() => handleTimeChange('last_30_days')} />
                                        </span>
                                        <span className="filter-option-text">Last 30 days</span>
                                    </label>
                                    <label className="filter-option" data-val="2024">
                                        <span className="filter-checkbox-label">
                                            <input type="checkbox" checked={filterTime[2024]} onChange={() => handleTimeChange('2024')} />
                                        </span>
                                        <span className="filter-option-text">2024</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="column orders-content-column">
                            <div className="search-container">
                                <label className="search-input-wrapper" htmlFor="orders-web-search-input">
                                    <input
                                        id="orders-web-search-input"
                                        type="text"
                                        className="search-input"
                                        placeholder="Search your orders here"
                                        value={searchVal}
                                        fdprocessedid="ma9z58"
                                        onChange={(e) => handleSearchChange(e.target.value)}
                                    />
                                </label>
                                <button class="search-button" fdprocessedid="ajv5wl">
                                    <div class="search-button-content">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 17 18"
                                            className="search-icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden
                                        >
                                            <g fill="currentColor" fillRule="evenodd">
                                                <path
                                                    class=""
                                                    d="m11.618 9.897l4.225 4.212c.092.092.101.232.02.313l-1.465 1.46c-.081.081-.221.072-.314-.02l-4.216-4.203"
                                                ></path>
                                                <path
                                                    class=""
                                                    d="m6.486 10.901c-2.42 0-4.381-1.956-4.381-4.368 0-2.413 1.961-4.369 4.381-4.369 2.42 0 4.381 1.956 4.381 4.369 0 2.413-1.961 4.368-4.381 4.368m0-10.835c-3.582 0-6.486 2.895-6.486 6.467 0 3.572 2.904 6.467 6.486 6.467 3.582 0 6.486-2.895 6.486-6.467 0-3.572-2.904-6.467-6.486-6.467"
                                                ></path>
                                            </g>
                                        </svg>
                                        <span onClick={searchProducts}>Search Orders</span>
                                    </div>
                                </button>
                            </div>
                            <div className="results-count">{totalOrderItemsCount === 0 ? '0 items found' : `${totalOrderItemsCount} ${totalOrderItemsCount === 1 ? 'item' : 'items'} found`}</div>
                            <div>
                                {!loading && orderData.length === 0 ? (
                                    <div className="empty-orders-container">
                                        <div className="empty-orders-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                                <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                                <path d="M9 14l2 2 4-4"></path>
                                            </svg>
                                        </div>
                                        <h2 className="empty-orders-title">No orders found</h2>
                                        <p className="empty-orders-message">You haven't placed any orders yet. Start shopping to see your orders here!</p>
                                        <button 
                                            className="empty-orders-button"
                                            onClick={() => window.location.href = '/'}
                                        >
                                            Start Shopping
                                        </button>
                                    </div>
                                ) : (
                                <div class="orders-list-container">
                                    <div
                                        class="orders-list-wrapper"
                                    >

                                        {
                                            orderData.map((order) => {
                                                const timelineStatus = getTimelineStatus(order.itemStatus, order.deliveryStatus);
                                                const visibleOptions = getOrderItemVisibleOptions(order);
                                                const progressPercent = getProgressPercent(order);
                                                return (
                                                    <div class="order-item-row" key={order.id}>
                                                        <div className="itemContainer-base-item">
                                                            <div className="itemContainer-base-itemLeft">
                                                                <img src={order?.urls?.[1] || order?.urls?.[0] || "https://via.placeholder.com/130x180"} alt={order?.title} />
                                                            </div>

                                                            <div className="itemContainer-base-itemRight">
                                                                <div className="brand-and-seller">
                                                                    <div>{order?.brand}</div>
                                                                    <a>{order?.title}</a>
                                                                </div>

                                                                <div className="itemComponents-base-sellerContainer">
                                                                    <div className="itemComponents-base-sellerData">
                                                                        Sold by: Puma Sports India Pvt. Ltd.(NSCM)
                                                                    </div>
                                                                </div>

                                                                <div className="itemContainer-base-price">
                                                                    <div>
                                                                        <img src={rupeesIcon} alt="" width={11} height={11} />
                                                                        {order?.price}
                                                                    </div>

                                                                    <div>
                                                                        <span>{order?.mrp}</span>
                                                                        <span>60% OFF</span>
                                                                    </div>
                                                                </div>

                                                                <div className="itemContainer-base-sizeAndQtyContainer">
                                                                    <div className="itemContainer-base-sizeAndQty">
                                                                        <div className="itemComponents-base-size">
                                                                            <span>
                                                                                <div>Size:</div>
                                                                                <div className="size-select-wrapper">
                                                                                    <div className="cart-select">
                                                                                        {order?.selectedSize || 'N/A'}
                                                                                    </div>
                                                                                </div>
                                                                            </span>
                                                                        </div>

                                                                        <div className="itemComponents-base-size">
                                                                            <span>
                                                                                <div>Qty:</div>
                                                                                <div className="quantity-controls">
                                                                                    <span className="quantity-value">{order?.selectedQty || 1}</span>
                                                                                </div>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="delivery-details delivery-details--horizontal">
                                                            <div className="container">
                                                                <div className="progress-header">
                                                                    <div className="progress-title">Delivery Progress</div>
                                                                    <div className="progress-percentage">{progressPercent}%</div>
                                                                </div>
                                                                
                                                                <div className="progress-bar-container">
                                                                    <div className="progress-fill" data-progress={progressPercent} style={{ width: `${progressPercent}%` }}></div>
                                                                    <div className="progress-indicators">
                                                                        <div className={`indicator processed ${timelineStatus.processed}`}></div>
                                                                        <div className={`indicator shipped ${timelineStatus.shipped}`}></div>
                                                                        <div className={`indicator on-the-way ${timelineStatus.onTheWay}`}></div>
                                                                        <div className={`indicator delivered ${timelineStatus.delivered}`}></div>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="progress-labels">
                                                                    <div className={`progress-label processed ${timelineStatus.processed}`}>Processed</div>
                                                                    <div className={`progress-label shipped ${timelineStatus.shipped}`}>Shipped</div>
                                                                    <div className={`progress-label on-the-way ${timelineStatus.onTheWay}`}>On the Way</div>
                                                                    <div className={`progress-label delivered ${timelineStatus.delivered}`}>Delivered</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="options">
                                                            {cancelledItemIds.includes(order.id) || (order.itemStatus || '').toString().toLowerCase() === 'cancelled' ? (
                                                                <button type="button" className="order-option-btn option-cancelled" disabled>Cancelled</button>
                                                            ) : (
                                                                visibleOptions.map((opt) => {
                                                                    if (opt === 'cancel') return (
                                                                        <button
                                                                            key={opt}
                                                                            type="button"
                                                                            className="order-option-btn order-option-btn--cancel"
                                                                            onClick={(e) => handleCancelClick(order, e)}
                                                                            disabled={!!cancellingOrder}
                                                                        >
                                                                            {cancellingOrder ? 'Cancelling...' : 'Cancel'}
                                                                        </button>
                                                                    );
                                                                    if (opt === 'track') return (
                                                                        <button
                                                                            key={opt}
                                                                            type="button"
                                                                            className="order-option-btn"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                openTrackModal(order);
                                                                            }}
                                                                        >
                                                                            Track
                                                                        </button>
                                                                    );
                                                                    if (opt === 'review') return (
                                                                        <button
                                                                            key={opt}
                                                                            type="button"
                                                                            className="order-option-btn"
                                                                            onClick={(e) => openFeedback(order, e)}
                                                                        >
                                                                            Feedback
                                                                        </button>
                                                                    );
                                                                    if (opt === 'view-review') return (
                                                                        <button
                                                                            key={opt}
                                                                            type="button"
                                                                            className="order-option-btn"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                openViewReviewModal(order);
                                                                            }}
                                                                        >
                                                                            View feedback
                                                                        </button>
                                                                    );
                                                                    return (
                                                                        <button
                                                                            key={opt}
                                                                            type="button"
                                                                            className="order-option-btn"
                                                                            onClick={(e) => openFeedback(order, e)}
                                                                        >
                                                                            Feedback
                                                                        </button>
                                                                    );
                                                                })
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                )}
                            </div>
                            {loading && !noMoreProducts && <div className="loader"></div>}
                            {!noMoreProducts && <div ref={lastProductRef}></div>}
                            {/* Add footer ref */}
                            {!noMoreProducts && <div ref={footerRef} className="fetch-stopper"></div>}
                            {noMoreProducts && orderData.length > 0 && (
                                <div className="no-more-results-container">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M9 11l3 3L22 4"></path>
                                        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                                    </svg>
                                    <span>All orders loaded</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Cancel Confirmation Modal */}
            {showCancelModal && (
                <div className="cancel-modal-overlay">
                    <div className="cancel-modal">
                        <div className="cancel-modal-header">
                            <h3>Cancel Order</h3>
                            <button 
                                className="cancel-modal-close" 
                                onClick={closeCancelModal}
                            >
                                ×
                            </button>
                        </div>
                        <div className="cancel-modal-body">
                            <p>Cancel this item?</p>
                            <p className="cancel-warning">
                                This action cannot be undone.
                            </p>
                        </div>
                        <div className="cancel-modal-footer">
                            <button 
                                className="cancel-btn-secondary" 
                                onClick={closeCancelModal}
                            >
                                Back
                            </button>
                            <button 
                                className="cancel-btn-primary" 
                                onClick={handleCancelItemConfirm}
                                disabled={cancellingOrder}
                            >
                                {cancellingOrder ? 'Cancelling...' : 'Yes, cancel item'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Track / Delivery Status Modal */}
            {showTrackModal && selectedOrder && (
                <div className="cancel-modal-overlay" onClick={closeTrackModal}>
                    <div className="cancel-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="cancel-modal-header">
                            <h3>Delivery info</h3>
                            <button type="button" className="cancel-modal-close" onClick={closeTrackModal} aria-label="Close">×</button>
                        </div>
                        <div className="cancel-modal-body">
                            <p><strong>Status:</strong> {trackInfo?.tracking?.currentStatus || selectedOrder.deliveryStatus || '—'}</p>
                            <p><strong>Expected delivery:</strong> {selectedOrder.deliveryDate || '—'}</p>
                            {(trackInfo?.shipping?.awb || selectedOrder.awb) && (
                                <p><strong>AWB:</strong> {trackInfo?.shipping?.awb || selectedOrder.awb}</p>
                            )}
                            {(trackInfo?.shipping?.courier_name || selectedOrder.courierName) && (
                                <p><strong>Courier:</strong> {trackInfo?.shipping?.courier_name || selectedOrder.courierName}</p>
                            )}
                            {trackLoading && <p>Refreshing live tracking…</p>}
                            {!trackLoading && trackInfo?.message && !trackInfo?.tracking && (
                                <p>{trackInfo.message}</p>
                            )}
                            {Array.isArray(trackInfo?.tracking?.activities) && trackInfo.tracking.activities.length > 0 && (
                                <ul style={{ marginTop: 12, paddingLeft: 18 }}>
                                    {trackInfo.tracking.activities.slice(0, 8).map((a, i) => (
                                        <li key={`${a.date || ''}-${i}`}>
                                            {a.date ? `${a.date} — ` : ''}{a.activity}
                                            {a.location ? ` (${a.location})` : ''}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {(trackInfo?.tracking?.trackUrl || trackInfo?.shipping?.tracking_url || selectedOrder.trackingUrl) && (
                                <p style={{ marginTop: 12 }}>
                                    <a
                                        href={trackInfo?.tracking?.trackUrl || trackInfo?.shipping?.tracking_url || selectedOrder.trackingUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Open courier tracking
                                    </a>
                                </p>
                            )}
                        </div>
                        <div className="cancel-modal-footer">
                            <button type="button" className="cancel-btn-primary" onClick={closeTrackModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* View feedback Modal */}
            {showViewReviewModal && selectedOrder && selectedOrder.reviewData && (
                <div className="cancel-modal-overlay" onClick={closeViewReviewModal}>
                    <div className="cancel-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="cancel-modal-header">
                            <h3>Your feedback</h3>
                            <button type="button" className="cancel-modal-close" onClick={closeViewReviewModal} aria-label="Close">×</button>
                        </div>
                        <div className="cancel-modal-body">
                            <p className="orders-view-review-product">{selectedOrder.title}</p>
                            <div className="orders-view-review-rating">
                                <span>Rating:</span>
                                {[1, 2, 3, 4, 5].map((n) => (
                                    <span key={n} className={Number(selectedOrder.reviewData.rating) >= n ? 'active' : ''}>★</span>
                                ))}
                            </div>
                            {selectedOrder.reviewData.comment && (
                                <p className="orders-view-review-comment">{selectedOrder.reviewData.comment}</p>
                            )}
                            {selectedOrder.reviewData.images && selectedOrder.reviewData.images.length > 0 && (
                                <div className="orders-view-review-images">
                                    {selectedOrder.reviewData.images.map((src, i) => (
                                        <img key={i} src={src} alt={`Review ${i + 1}`} className="orders-view-review-thumb" />
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="cancel-modal-footer">
                            <button type="button" className="cancel-btn-primary" onClick={closeViewReviewModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
